import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { installVisibleTextPolicy } from './utils/visibleTextPolicy'
import AppErrorBoundary from './components/AppErrorBoundary'
import { installGlobalErrorHandlers } from './utils/errorReporting'
// import './global.css'

//import './global_purged.css'

import './index.css'

// Report uncaught errors + unhandled rejections outside React's render tree.
installGlobalErrorHandlers()
installVisibleTextPolicy()

ReactDOM.createRoot(
  document.getElementById("root"),
)
.render(
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
)
